export enum ReurbModalidade {
  REURB_S = 'REURB_S',
  REURB_E = 'REURB_E',
}
